import { render, staticRenderFns } from "./view-subject.view.vue?vue&type=template&id=5fa3c72e&scoped=true&"
import script from "./view-subject.view.ts?vue&type=script&lang=ts&"
export * from "./view-subject.view.ts?vue&type=script&lang=ts&"
import style0 from "./view-subject.view.scss?vue&type=style&index=0&id=5fa3c72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3c72e",
  null
  
)

export default component.exports